import jsCookie from "js-cookie";
import moment from "moment";

export const TOKEN_NAME = "token";

export const setToken = (token: string) => {
  jsCookie.set(TOKEN_NAME, token);
};

export const getToken = (): string | undefined => {
  return jsCookie.get(TOKEN_NAME);
};

export const removeToken = (): void => {
  jsCookie.remove(TOKEN_NAME);
};

export const rotateBase64 = (data: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const imgView = new Image();
    imgView.src = data;
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; // 裁剪坐标
    imgView.onload = () => {
      const imgW = imgView.width;
      const imgH = imgView.height;
      const size = imgH;
      canvas.width = size * 2;
      canvas.height = size * 2;
      cutCoor.sx = size;
      cutCoor.sy = size - imgW;
      cutCoor.ex = size + imgH;
      cutCoor.ey = size + imgW;
      if (context) {
        context.translate(size, size);
        context.rotate((Math.PI / 2) * 3);
        context.drawImage(imgView, 0, 0);
        const imgData = context.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
        canvas.width = imgH;
        canvas.height = imgW;
        context.putImageData(imgData, 0, 0);
      }
      resolve(canvas.toDataURL("image/png"));
    };
  });
};

export const getTitle = (list: Array<any>, id: string | number, text: string) => {
  if (!id) return text;
  let title = "";
  list.forEach((i: any) => {
    if (i.value === id) title = i.text;
  });

  return title || text;
};

export const isSameDay = (date: string | number, max = "2099-12-31") => {
  const maxData = moment(max).valueOf();
  const isBefore = moment(maxData).isBefore(date, "day"); //判断最大日期是否在选择时间结束时间之前
  const isSame = moment(maxData).isSame(date, "day"); //判断最大日期与选择时间结束时间是否是同一天

  return isBefore || isSame;
};

// 切分数字
export const splitNum = (value: string, num: number) => {
  if (!value) return value;
  let isHas = value.indexOf(".") !== -1; //判断是不是小数
  if (!isHas) return value; //如果是整数直接返回

  let [integer, decimal] = value.split("."); //有小树点时需要去除字符串后的0
  const str = decimal ? `.${decimal.substring(0, num)}` : ".";
  return `${integer}${str}`;
};

// url 图片转成base64
export const convertImageToBase64 = (url: string, callback: Function) => {
  fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const reader = new FileReader();
      reader.onload = function() {
        callback(reader.result);
      };
      reader.readAsDataURL(blob);
    });
};
